import _ from 'lodash';
import Category from '../Model/Category';
import AppService from 'App/legacy/AppService';

type RawCategory = Optional<Category, '$hasAccess'>;

// Return true ore false if the user can se the stage
const hasRoleAccess = function (field: RawCategory, roleId: number | null, admin: boolean) {
	if (admin || !field.roles?.length || _.find(field.roles, { id: roleId })) {
		return true;
	}

	return false;
};

export default function parseCategory(category: RawCategory) {
	const self = AppService.getSelf();
	category.$hasAccess = hasRoleAccess(category, self.role?.id || null, self.administrator);

	return category as Category;
}
